import Nav from '../../components/breadcrumb';
import PageHeader, { Title, ActionBar, ActionButton as Btn, ButtonToolbar } from '../../components/pageheader';
import { Table } from 'react-bootstrap';
import { Link, Route, Routes, useParams } from 'react-router-dom';
import { useEffect, useState, useContext } from 'react';
import { ErrorLoading, PageLoading } from '../../components/loading';
import moment from "moment";
import { UCWords } from '../../components/resources';
import cur from '../../components/currency';
import { ConfirmAction } from '../../components/prompt';
import { errorAlert, infoAlert, successAlert } from '../../components/toastr';
import { AppUserContext } from '../../App';
import { APIURL } from '../../resources/fetch';
import { changeVoucherStatus, executePayments, getVoucher } from '../../resources/api/payment-vouchers';
import { EditVoucher } from './voucher-manipulation';


/**
 * handle for /app/expenses/:expenseid
 * @param {Object} props
 * @param {import('../../resources/api/payment-vouchers').PaymentVoucherObject} props.details
 * 
 */
const ViewVoucher = ({ details, setDetails }) => {

    const { profile } = useContext(AppUserContext);

    const nav_items = [
        { title: 'Payment Vouchers', href: '/app/payment-vouchers' },
        { title: details.voucher_no }
    ];

    const style1 = { width: '150px', display: 'inline-block', fontWeight: 'normal' };

    const changeStatus = (action) => {

        let status;

        switch (action) {
            case "approve":
                status = "approved"
                break;

            case "draft":
                status = "pending"
                break;

            default:
                errorAlert("unknown action...");
                return;
        }

        infoAlert("Changing the requisition status ...");

        changeVoucherStatus(details.id, status)
            .then(({ voucher, message }) => {
                successAlert(message);
                setDetails(d => ({ ...d, ...voucher }));
            })
            .catch(e => errorAlert(e))
    }

    const payVoucher = () => {
        executePayments(details.id)
            .then(({ voucher, message }) => {
                successAlert(message);
                setDetails(d => ({ ...d, ...voucher }));
            })
            .catch(e => errorAlert(e))
    }

    return (
        <>
            <Nav items={nav_items} />

            <PageHeader maxWidth="900">
                <Title>
                    {details.voucher_no}
                </Title>
                <ActionBar>

                    <ButtonToolbar>
                        <Btn title="Download PDF" href={`${APIURL}/requisitions/${details.id}/pdf`} isExternalLink>
                            <i className="fas fa-file-pdf" />
                        </Btn>
                    </ButtonToolbar>

                    {((details.status === "pending") && (profile.permission_level < 2)) &&
                        <ButtonToolbar>
                            <ConfirmAction
                                as={Btn}
                                title="Approve Voucher"
                                handleAction={() => changeStatus('approve')}
                                confirmationText='Are you sure you want to approve this voucher for processing?'
                            >
                                <i className="fas fa-upload" />
                            </ConfirmAction>
                        </ButtonToolbar>
                    }

                    {((details.status === "approved") && (profile.permission_level < 2)) &&
                        <ButtonToolbar>
                            <ConfirmAction
                                as={Btn}
                                title="Revert to Draft"
                                handleAction={() => changeStatus('draft')}
                                confirmationText='Are you sure you want to draft & revert this voucher to draft status?'
                            >
                                <i className="fas fa-times-circle" />
                            </ConfirmAction>

                            <ConfirmAction
                                as={Btn}
                                title="Pay"
                                handleAction={() => payVoucher()}
                                confirmationText='Are you sure you want to pay this voucher?'
                            >
                                <i className="fas fa-check-circle" />
                            </ConfirmAction>
                        </ButtonToolbar>
                    }

                    <ButtonToolbar>
                        {(details.status === "pending") &&
                            <Btn href={`/app/payment-vouchers/${details.id}/edit`} title="Edit Payment Voucher">
                                <i className="fas fa-pencil-alt" />
                            </Btn>}
                        <Btn href="/app/payment-vouchers/new" title="New Voucher">
                            <i className="fas fa-plus-circle" />
                        </Btn>
                    </ButtonToolbar>
                </ActionBar>
            </PageHeader>

            <div className="max-800 p-1 expenses">

                <div className="text-end">
                    VOUCHER NO: <span style={style1}>{details.voucher_no}</span> <br />
                    VOUCHER DATE: <span style={style1}>{moment(details.voucher_date).format("DD MMMM YYYY")}</span> <br />
                    STATUS: <span style={style1}>{UCWords(details.status.replace(/-/g, " "))}</span><br />
                </div>

                <div className="my-3">
                    <span style={{ height: '100px' }} className="px-3 px-sm-4 d-inline-flex align-items-center justify-content-end bg-teal text-white font-weight-bold rounded">
                        UGX <span style={{ fontSize: '2rem' }} className="d-inline-block ms-2">{cur(details.total_amount).format()}</span>
                    </span>
                </div>




                <Table size="sm" borderless style={{ maxWidth: '600px' }}>
                    <colgroup>
                        <col span="1" style={{ width: "40%" }} />
                        <col span="1" style={{ width: "60%" }} />
                    </colgroup>

                    <tbody>
                        <tr>
                            <td>Approved</td>
                            <td>
                                {!details.isApproved ?
                                    "Not Approved" :
                                    <span>By {details.approver.display_name} on {moment(details.date_approved).format("DD MMMM YYYY")}</span>
                                }
                            </td>
                        </tr>
                        {/* <tr>
                            <td>Paid</td>
                            <td>
                                {!details.isPaid ?
                                    "Not Paid" :
                                    <span>On {moment(details.date_paid).format("DD MMMM YYYY")}</span>
                                }
                            </td>
                        </tr> */}
                    </tbody>
                </Table>

                {(details.requisitions.length > 0) && <>

                    <div className="mt-3">
                        <h5>Requisitions</h5>
                        <Table responsive hover>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Ref </th>
                                    <th>User</th>
                                    <th>Date</th>
                                    <th style={{ textAlign: 'right' }}>Amount</th>
                                    <th>Approved On</th>
                                </tr>

                            </thead>
                            <tbody>
                                {details.requisitions.map((e, i) => (
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td><Link to={`/app/requisitions/${e.id}`}>{e.reference}</Link></td>
                                        <td>{e.display_name}</td>
                                        <td>{moment(e.requisition_date).format("DD MMM YYYY")}</td>
                                        <td style={{ textAlign: 'right' }}>{cur(e.total_amount, 0).format()}</td>
                                        <td>{!!e.date_approved ? moment(e.date_approved).format("DD MMM YYYY") : "n/a"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>

                </>}

                {(details.staff_payments.length > 0) && <>
                    <h5>Staff Payments</h5>
                    <Table responsive hover>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Amount</th>
                                <th>Approved</th>
                                <th>Paid</th>
                            </tr>
                        </thead>
                        <tbody>
                            {details.staff_payments.map((i, idx) => (
                                <tr key={i.id}>
                                    <td>{idx + 1}</td>
                                    <td>{i.name}</td>
                                    <td>{UCWords(i.payroll_type.replace(/-/g, " "))}</td>
                                    <td>{cur(i.amount, 0).format()}</td>
                                    <td>{i.isProcessed ? moment(i.date_approved).format("DD MMM YYYY") : "Not Processed"}</td>
                                    <td>{i.isPaid ? "Yes" : "No"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </>}



            </div>
        </>
    )
}




const VoucherDetails = () => {

    const { voucherid } = useParams();
    const [details, setDetails] = useState({});
    const [isLoaded, setLoaded] = useState(false);
    const [error, setError] = useState();

    useEffect(() => {

        setError(null);
        setLoaded(false);

        getVoucher(voucherid, ['requisitions', 'staff_payments'])
            .then(({ voucher }) => {
                setDetails(voucher);
            })
            .catch(e => setError(e))
            .finally(() => setLoaded(true))

    }, [voucherid])

    //load events details

    if (!isLoaded) {
        return <PageLoading>Loading voucher details...</PageLoading>
    }

    if (error) {
        return <ErrorLoading>{error}</ErrorLoading>
    }

    return (
        <Routes>
            <Route path="/edit" element={<EditVoucher details={details} setDetails={setDetails} />} />
            <Route path="/" element={<ViewVoucher details={details} setDetails={setDetails} />} />
        </Routes>
    )

}

export default VoucherDetails;